/*eslint complexity: off*/
import React from 'react';
import moment from 'moment';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import FaceIcon from '@material-ui/icons/Face';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';

import InputLabel from '@material-ui/core/InputLabel';
import Chip from '@material-ui/core/Chip';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import InputShow from '~/components/InputShow';

// "Pressão Arterial: 130 x 80mmHg\nTemperatura: 36°C" -> [{label,value}]
function parseTriagem(texto) {
  if (!texto) return [];
  return String(texto)
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean)
    .map((l) => {
      const i = l.indexOf(':');
      return i === -1
        ? { label: null, value: l }
        : { label: l.slice(0, i).trim(), value: l.slice(i + 1).trim() };
    });
}

function Section({ title, children }) {
  return (
    <GridContainer>
      <GridItem xs={12}>
        <InputLabel shrink style={{ marginBottom: 8, marginTop: 8 }}>
          {title}
        </InputLabel>
        {children}
      </GridItem>
    </GridContainer>
  );
}

export function SusRecordShowForm({ atendimento }) {
  const [hiddenCard, setHiddenCard] = React.useState(true);
  const a = atendimento || {};

  const dataFmt = a.data
    ? moment(a.data, 'YYYY-MM-DDTHH:mm:ss').format('D [de] MMMM [de] YYYY [às] HH:mm')
    : '-';

  const triagem = parseTriagem(a.triagem);
  const prescricoes = a.prescricoes || [];
  const exames = a.exames || [];
  const procedimentos = a.procedimentos || [];
  const resultadosExames = a.resultadosExames || [];

  return (
    <Card
      style={{
        maxHeight: hiddenCard ? '300px' : '100%',
        marginBottom: 15,
        zIndex: -1,
        display: 'grid',
        gridTemplateColumns: '1fr',
      }}
    >
      {hiddenCard && (
        <div
          style={{
            width: '100%',
            height: '300px',
            background:
              'linear-gradient(to top, #ffffff, transparent, transparent, transparent)',
            zIndex: 1,
            gridRowStart: 1,
            gridColumnStart: 1,
            pointerEvents: 'none',
          }}
        />
      )}

      <div style={{ padding: 10, gridRowStart: 1, gridColumnStart: 1 }}>
        <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <KeyboardArrowDownIcon
            onClick={() => setHiddenCard(!hiddenCard)}
            style={{
              cursor: 'pointer',
              transform: hiddenCard ? 'rotate(0deg)' : 'rotate(180deg)',
              zIndex: 2,
            }}
          />
        </Box>

        <CardContent>
          <GridContainer spacing={4}>
            <GridItem xs={12} sm={6} md={4}>
              <InputShow label={'Data'} value={dataFmt} />
            </GridItem>
            <GridItem xs={12} sm={6} md={5}>
              <InputShow label={'Local da consulta'} value={a.unidade || '-'} />
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <InputShow label={'Ficha'} value={a.id || '-'} />
            </GridItem>
          </GridContainer>

          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <InputLabel shrink style={{ marginBottom: 10 }}>
                {'Profissional'}
              </InputLabel>
              <Chip
                icon={<FaceIcon />}
                label={a.profissional || '-'}
                variant="outlined"
                color="primary"
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <InputLabel shrink style={{ marginBottom: 10 }}>
                {'Especialidade'}
              </InputLabel>
              <Chip
                icon={<LocalHospitalIcon />}
                label={a.especialidade || '-'}
                variant="outlined"
              />
            </GridItem>
          </GridContainer>

          {a.anamnese && (
            <Section title={'Anamnese'}>
              <Typography
                style={{ textAlign: 'justify', lineHeight: '1.7em', whiteSpace: 'pre-line' }}
              >
                {a.anamnese}
              </Typography>
            </Section>
          )}

          {triagem.length > 0 && (
            <Section title={'Triagem / Dados clínicos'}>
              <GridContainer>
                {triagem.map((t, k) => (
                  <GridItem key={k} xs={12} sm={6} md={4}>
                    <InputShow label={t.label || ' '} value={t.value} />
                  </GridItem>
                ))}
              </GridContainer>
            </Section>
          )}

          {prescricoes.length > 0 && (
            <Section title={'Prescrições'}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Medicamento</TableCell>
                    <TableCell>Qtde</TableCell>
                    <TableCell>Posologia</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {prescricoes.map((p, k) => (
                    <TableRow key={k}>
                      <TableCell>{p.medicamento}</TableCell>
                      <TableCell>
                        {[p.quantidade, p.unidade].filter(Boolean).join(' ')}
                      </TableCell>
                      <TableCell>{p.posologia}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Section>
          )}

          {exames.length > 0 && (
            <Section title={'Exames solicitados'}>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {exames.map((e, k) => (
                  <li key={k}>
                    <Typography component="span">
                      {e.descricao}
                      {e.procedimento ? ` (${e.procedimento})` : ''}
                    </Typography>
                  </li>
                ))}
              </ul>
            </Section>
          )}

          {procedimentos.length > 0 && (
            <Section title={'Procedimentos realizados'}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Procedimento</TableCell>
                    <TableCell>Qtde</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {procedimentos.map((p, k) => (
                    <TableRow key={k}>
                      <TableCell>
                        {p.descricao}
                        {p.classificacao ? ` (${p.classificacao})` : ''}
                      </TableCell>
                      <TableCell>
                        {p.quantidade === null || p.quantidade === undefined
                          ? '-'
                          : p.quantidade}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Section>
          )}

          {resultadosExames.length > 0 && (
            <Section title={'Resultados de exames'}>
              {resultadosExames.map((r, k) => (
                <Box key={k} style={{ marginBottom: 12 }}>
                  <Typography style={{ fontWeight: 500 }}>
                    {r.descricao}
                    {r.data
                      ? ` — ${moment(r.data, 'YYYY-MM-DD').format('DD/MM/YYYY')}`
                      : ''}
                  </Typography>
                  {r.resultado && (
                    <Typography
                      component="div"
                      style={{
                        whiteSpace: 'pre-line',
                        lineHeight: '1.6em',
                        marginTop: 4,
                      }}
                    >
                      {r.resultado}
                    </Typography>
                  )}
                </Box>
              ))}
            </Section>
          )}
        </CardContent>
      </div>
    </Card>
  );
}
